import * as React from "react";
import { useState, useContext, useEffect } from "react";
import Paper from "@mui/material/Paper";
import InputBase from "@mui/material/InputBase";
import { Button, TextField, Divider } from "@mui/material";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import Fab from "@mui/material/Fab";
import ClosedCaptionIcon from "@mui/icons-material/ClosedCaption";
import MainContext from "../../../context/mainContext";
import Skeleton from "@mui/material/Skeleton";
import SearchSubtitlesResult from "./SearchSubtitlesResult";
import {
  findSubtitlesApi,
  findSubtitlesWithIdApi,
} from "../../../services/subtitlesApi";
import {
  customToastify,
  checkErrorMessage,
  checkResponseData,
} from "../../pages/utils/utilsFunctions";
import { toast } from "react-toastify";
import Typography from "@mui/material/Typography";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import ButtonGroup from "@mui/material/ButtonGroup";
import DeleteIcon from "@mui/icons-material/Delete";

export default function CompareSubsPlayingSerachBox(props) {
  const { handleVideoInfo, videoInfo } = useContext(MainContext);

  const {
    openSearchBox,
    handleOpenSearchBox,
    handleMeainCompareSubsDialog,
    handleSubtitlesListId,
    subtitlesListId,
  } = props;
  const [isSerial, setIsSerial] = useState(false);
  const [nameOfMovie, setNameOfMovie] = useState("");
  const [subtitlesUploadId, setSubtitlesUploadId] = useState("");
  const [episode, setEpisode] = useState("");
  const [season, setSeason] = useState("");
  const [subtitlesLanguage, setSubtitlesLanguage] = useState("all");
  const [searchById, setSearchById] = useState(false);
  const [recivedData, setRecivedData] = useState([]);
  const [resultState, setResultState] = useState("searching");
  const [countPage, setCountPage] = React.useState(1);
  const [page, setPage] = React.useState(1);
  const handleChangePage = (event, value) => {
    setPage(value);
    if (searchById) handleSearchClick("id", value, 50);
    else handleSearchClick("name", value, 50);
  };

  const handleChangeMovieInfo = (type, value) => {
    const newValues = {};
    if (type == "videoType") {
      setIsSerial(value == "Serial");
      newValues["videoType"] = value;
      if (!value) {
        setEpisode(null);
        setSeason(null);
        newValues["season"] = "";
        newValues["episode"] = "";
      }
    } else if (type == "filmName") {
      setNameOfMovie(value);
      newValues["filmName"] = value;
    } else if (type == "season") {
      setSeason(value);
      newValues["season"] = value;
    } else if (type == "episode") {
      setEpisode(value);
      newValues["episode"] = value;
    }
    handleVideoInfo({
      ...videoInfo,
      ...newValues,
    });
  };

  const handleSearchClick = (type, page, perPage) => {
    if (type == "id") {
      if (subtitlesUploadId.length > 0)
        searchSubtitle(
          "id",
          { subtitlesUploadId },
          { page: page || 1, perPage: perPage || 50 }
        );
      else customToastify("warning", "لطفا آی دی زیرنویس را وارد کنید");
    } else {
      if (nameOfMovie.length > 0) {
        let data = {
          subtitlesLanguage: subtitlesLanguage,
          nameOfMovie: nameOfMovie,
          season: isSerial ? season : "",
          episode: isSerial ? episode : "",
        };
        searchSubtitle("name", data, { page: page || 1, perPage });
      } else customToastify("warning", "لطفا نام فیلم یا سریال را وارد کنید");
    }
  };

  const searchSubtitle = async (type, data, paginate) => {
    setResultState("searching");
    const toastMsg = toast.loading("لطفا صبر کنید...");
    try {
      let response;
      if (type == "id") response = await findSubtitlesWithIdApi(data);
      else response = await findSubtitlesApi(data, paginate);
      const resData = checkResponseData(response);
      if (resData["success"]) {
        if (type == "id") {
          if (resData["data"]["data"][0]["subtitlesUploadId"])
            setRecivedData(resData["data"]["data"]);
          else setRecivedData([]);
        } else setRecivedData(resData["data"]["docs"]);
        setCountPage(resData["data"]["totalPages"]);
        toast.update(toastMsg, {
          render: resData["message"] || "درخواست انجام شد",
          type: "success",
          isLoading: false,
          autoClose: 500,
        });
      } else {
        toast.update(toastMsg, {
          render: resData["message"] || "اتفاق غیر منتظره پیش آمده است",
          type: "info",
          isLoading: false,
          autoClose: 500,
        });
      }
      setResultState("answer");
    } catch (error) {
      console.error(error);
      setResultState("error");
      const errData = checkErrorMessage(error);
      let errMsg = errData["titles"] || errData["message"];
      toast.update(toastMsg, {
        render: errMsg || "مشکلی وجود دارد",
        type: "error",
        isLoading: false,
        autoClose: 3000,
      });
    }
  };

  useEffect(() => {
    if (openSearchBox) {
      setIsSerial(videoInfo.videoType == "Serial");
      if (videoInfo.filmName) {
        setNameOfMovie(videoInfo.filmName);
        searchSubtitle(
          "name",
          {
            nameOfMovie: videoInfo.filmName,
            season: videoInfo.videoType == "Serial" ? videoInfo.season : "",
            episode: videoInfo.videoType == "Serial" ? videoInfo.episode : "",
          },
          { page: 1, perPage: 50 }
        );
      } else {
        setResultState("error");
      }
      setEpisode(videoInfo.episode);
      setSeason(videoInfo.season);
      setPage(1);
    }
  }, [openSearchBox]);

  return (
    <Paper
      sx={{
        display: openSearchBox ? "block !important" : "none !important",
        position: "fixed",
        width: "-webkit-fill-available",
        height: "100vh",
        top: "0px",
        left: "0px",
        zIndex: "999",
        overflow: "scroll",
      }}
    >
      <>
        <Box>
          <ButtonGroup variant="contained" aria-label="Basic button group">
            <Button
              disabled
              key={`subids-0`}
              size="small"
              variant="outlined"
            >{`${subtitlesListId.length} زیرنویس:`}</Button>
            {subtitlesListId.map((sub, idx) => (
              <Button
                key={`subids-${idx + 2}`}
                size="small"
                endIcon={
                  <DeleteIcon
                    onClick={() => {
                      handleSubtitlesListId("deleteId", sub, idx);
                    }}
                    color="warning"
                  />
                }
              >
                {sub}
              </Button>
            ))}
          </ButtonGroup>
          <br />
          <Button
            variant="contained"
            size="small"
            color="success"
            onClick={() => {
              handleOpenSearchBox(false);
              handleMeainCompareSubsDialog(true);
            }}
            sx={{ my: 0.5 }}
          >
            ادامه مراحل
          </Button>
          <Typography
            sx={{ textAlign: "start", fontSize: "12px" }}
          >{`نام فایل: ${videoInfo.fileName}`}</Typography>
        </Box>
        <Divider sx={{ textAlign: "center" }} />
        <Box sx={{ display: "flex", width: " 100%" }}>
          <Box
            onClick={() => {
              handleChangeMovieInfo("videoType", isSerial ? "movie" : "Serial");
            }}
            aria-label="menu"
          >
            <Fab size="small" color={isSerial ? "success" : "info"}>
              {isSerial ? "سریال" : "فیلم"}
            </Fab>
          </Box>
          <FormControl sx={{ m: 1, minWidth: 80 }}>
            <select
              label="subtitleLanguage"
              name="subtitleLanguage"
              value={subtitlesLanguage}
              onChange={(e) => {
                setSubtitlesLanguage(e.target.value);
              }}
            >
              <option autoFocus key={0} value="all">
                همه زبانها
              </option>
              <option autoFocus key={1} value="en">
                English
              </option>
              <option autoFocus key={2} value="fa">
                Persian
              </option>
              <option autoFocus key={3} value="de">
                German
              </option>
              <option autoFocus key={4} value="fr">
                French
              </option>
              <option autoFocus key={5} value="it">
                Italian
              </option>
              <option autoFocus key={6} value="tr">
                Turkish
              </option>
            </select>
          </FormControl>
          {isSerial ? (
            <>
              <TextField
                size="small"
                value={season}
                InputProps={{
                  inputProps: { min: "0", max: "1000", step: "1" },
                }}
                type="number"
                onChange={(e) => {
                  if (e.target.value == 0) {
                    handleChangeMovieInfo("season", null);
                  } else {
                    handleChangeMovieInfo("season", e.target.value);
                  }
                }}
                sx={{ width: "100px", m: 0.5 }}
                label="فصل"
              />
              <TextField
                size="small"
                value={episode}
                InputProps={{
                  inputProps: { min: "0", max: "1000", step: "1" },
                }}
                type="number"
                onChange={(e) => {
                  if (e.target.value == 0) {
                    handleChangeMovieInfo("episode", null);
                  } else {
                    handleChangeMovieInfo("episode", e.target.value);
                  }
                }}
                sx={{ width: "100px", m: 0.5 }}
                label="قسمت"
              />
            </>
          ) : null}
          <InputBase
            sx={{ ml: 1, flex: 1 }}
            placeholder="نام فیلم یا سریال"
            inputProps={{ "aria-label": "نام فیلم یا سریال" }}
            value={nameOfMovie}
            onChange={(e) => {
              handleChangeMovieInfo("filmName", e.target.value);
            }}
          />
          <Button
            size="small"
            onClick={() => {
              handleSearchClick("name");
            }}
            variant="contained"
            type="button"
            aria-label="search"
          >
            جست و جو
            <ClosedCaptionIcon size="small" sx={{ mx: 1 }} />
          </Button>
        </Box>
      </>

      <Divider sx={{ textAlign: "center" }}>نتایج جستجو :</Divider>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          width: " 100%",
          flexDirection: "column",
        }}
      >
        {resultState == "searching" ? (
          <Box sx={{ width: "95%" }}>
            <Skeleton />
            <Skeleton />
            <Skeleton />
          </Box>
        ) : (
          <>
            {resultState == "answer" ? (
              <>
                <SearchSubtitlesResult
                  handleSubtitlesListId={handleSubtitlesListId}
                  recivedData={recivedData}
                  movieData={{episode,season,nameOfMovie,isSerial}}
                />
                <Stack spacing={2}>
                  <Pagination
                    onChange={handleChangePage}
                    page={page}
                    count={countPage}
                    variant="outlined"
                    color="primary"
                  />
                </Stack>
              </>
            ) : (
              <Box sx={{ width: "95%", color: "red" }}>
                <Typography>
                  - عنوان فیلم یا زیرنویس را به درستی وارد کنید
                </Typography>
                <Typography>
                  -برای تنظیم شماره فصل و قسمت سریال روی دکمه فیلم کلیک کنید
                </Typography>
              </Box>
            )}
          </>
        )}
        <Box>
          <Button
            sx={{ m: 1, mb: 8 }}
            variant="contained"
            color="success"
            onClick={() => {
              handleOpenSearchBox(false);
              handleMeainCompareSubsDialog(true);
            }}
          >
            ادامه مراحل
          </Button>
        </Box>
      </Box>
    </Paper>
  );
}

// const languagesList = {
//   ab: "Abkhazian",
//   aa: "Afar",
//   af: "Afrikaans",
//   ak: "Akan",
//   sq: "Albanian",
//   am: "Amharic",
//   ar: "Arabic",
//   an: "Aragonese",
//   hy: "Armenian",
//   as: "Assamese",
//   av: "Avaric",
//   ae: "Avestan",
//   ay: "Aymara",
//   az: "Azerbaijani",
//   bm: "Bambara",
//   ba: "Bashkir",
//   eu: "Basque",
//   be: "Belarusian",
//   bn: "Bengali",
//   bh: "Bihari languages",
//   bi: "Bislama",
//   bs: "Bosnian",
//   br: "Breton",
//   bg: "Bulgarian",
//   my: "Burmese",
//   ca: "Catalan, Valencian",
//   km: "Central Khmer",
//   ch: "Chamorro",
//   ce: "Chechen",
//   ny: "Chichewa, Chewa, Nyanja",
//   zh: "Chinese",
//   cu: "Church Slavonic, Old Bulgarian, Old Church Slavonic",
//   cv: "Chuvash",
//   kw: "Cornish",
//   co: "Corsican",
//   cr: "Cree",
//   hr: "Croatian",
//   cs: "Czech",
//   da: "Danish",
//   dv: "Divehi, Dhivehi, Maldivian",
//   nl: "Dutch, Flemish",
//   dz: "Dzongkha",
//   en: "English",
//   eo: "Esperanto",
//   et: "Estonian",
//   ee: "Ewe",
//   fo: "Faroese",
//   fj: "Fijian",
//   fi: "Finnish",
//   fr: "French",
//   ff: "Fulah",
//   gd: "Gaelic, Scottish Gaelic",
//   gl: "Galician",
//   lg: "Ganda",
//   ka: "Georgian",
//   de: "German",
//   ki: "Gikuyu, Kikuyu",
//   el: "Greek (Modern)",
//   kl: "Greenlandic, Kalaallisut",
//   gn: "Guarani",
//   gu: "Gujarati",
//   ht: "Haitian, Haitian Creole",
//   ha: "Hausa",
//   he: "Hebrew",
//   hz: "Herero",
//   hi: "Hindi",
//   ho: "Hiri Motu",
//   hu: "Hungarian",
//   is: "Icelandic",
//   io: "Ido",
//   ig: "Igbo",
//   id: "Indonesian",
//   ia: "Interlingua (International Auxiliary Language Association)",
//   ie: "Interlingue",
//   iu: "Inuktitut",
//   ik: "Inupiaq",
//   ga: "Irish",
//   it: "Italian",
//   ja: "Japanese",
//   jv: "Javanese",
//   kn: "Kannada",
//   kr: "Kanuri",
//   ks: "Kashmiri",
//   kk: "Kazakh",
//   rw: "Kinyarwanda",
//   kv: "Komi",
//   kg: "Kongo",
//   ko: "Korean",
//   kj: "Kwanyama, Kuanyama",
//   ku: "Kurdish",
//   ky: "Kyrgyz",
//   lo: "Lao",
//   la: "Latin",
//   lv: "Latvian",
//   lb: "Letzeburgesch, Luxembourgish",
//   li: "Limburgish, Limburgan, Limburger",
//   ln: "Lingala",
//   lt: "Lithuanian",
//   lu: "Luba-Katanga",
//   mk: "Macedonian",
//   mg: "Malagasy",
//   ms: "Malay",
//   ml: "Malayalam",
//   mt: "Maltese",
//   gv: "Manx",
//   mi: "Maori",
//   mr: "Marathi",
//   mh: "Marshallese",
//   ro: "Moldovan, Moldavian, Romanian",
//   mn: "Mongolian",
//   na: "Nauru",
//   nv: "Navajo, Navaho",
//   nd: "Northern Ndebele",
//   ng: "Ndonga",
//   ne: "Nepali",
//   se: "Northern Sami",
//   no: "Norwegian",
//   nb: "Norwegian Bokmål",
//   nn: "Norwegian Nynorsk",
//   ii: "Nuosu, Sichuan Yi",
//   oc: "Occitan (post 1500)",
//   oj: "Ojibwa",
//   or: "Oriya",
//   om: "Oromo",
//   os: "Ossetian, Ossetic",
//   pi: "Pali",
//   pa: "Panjabi, Punjabi",
//   ps: "Pashto, Pushto",
//   fa: "Persian",
//   pl: "Polish",
//   pt: "Portuguese",
//   qu: "Quechua",
//   rm: "Romansh",
//   rn: "Rundi",
//   ru: "Russian",
//   sm: "Samoan",
//   sg: "Sango",
//   sa: "Sanskrit",
//   sc: "Sardinian",
//   sr: "Serbian",
//   sn: "Shona",
//   sd: "Sindhi",
//   si: "Sinhala, Sinhalese",
//   sk: "Slovak",
//   sl: "Slovenian",
//   so: "Somali",
//   st: "Sotho, Southern",
//   nr: "South Ndebele",
//   es: "Spanish, Castilian",
//   su: "Sundanese",
//   sw: "Swahili",
//   ss: "Swati",
//   sv: "Swedish",
//   tl: "Tagalog",
//   ty: "Tahitian",
//   tg: "Tajik",
//   ta: "Tamil",
//   tt: "Tatar",
//   te: "Telugu",
//   th: "Thai",
//   bo: "Tibetan",
//   ti: "Tigrinya",
//   to: "Tonga (Tonga Islands)",
//   ts: "Tsonga",
//   tn: "Tswana",
//   tr: "Turkish",
//   tk: "Turkmen",
//   tw: "Twi",
//   ug: "Uighur, Uyghur",
//   uk: "Ukrainian",
//   ur: "Urdu",
//   uz: "Uzbek",
//   ve: "Venda",
//   vi: "Vietnamese",
//   vo: "Volap_k",
//   wa: "Walloon",
//   cy: "Welsh",
//   fy: "Western Frisian",
//   wo: "Wolof",
//   xh: "Xhosa",
//   yi: "Yiddish",
//   yo: "Yoruba",
//   za: "Zhuang, Chuang",
//   zu: "Zulu",
// };
